export const adminNavSections = [
  {
    key: 'store',
    icon: '🏬',
    titleKey: 'nav.dropdown.store',
    items: [
      {
        to: '/admin/products',
        icon: '📦',
        labelKey: 'nav.dropdown.products',
      },
      {
        to: '/admin/categories',
        icon: '🗂️',
        labelKey: 'nav.dropdown.categories',
      },
      {
        to: '/admin/coupons',
        icon: '🎫',
        labelKey: 'nav.dropdown.coupons',
      },
      {
        to: '/admin/call-requests',
        icon: '📞',
        labelKey: 'nav.dropdown.callRequestsShort',
      },
      {
        to: '/admin/orders',
        icon: '📋',
        labelKey: 'nav.dropdown.orders',
      },
      {
        to: '/admin/users',
        icon: '👥',
        labelKey: 'nav.dropdown.users',
      },
    ],
  },
  {
    key: 'hubAdmin',
    icon: '🛠️',
    titleKey: 'nav.dropdown.hubAdmin',
    items: [
      {
        to: '/admin/hub/games',
        icon: '🎮',
        labelKey: 'nav.dropdown.hubGames',
      },
      {
        to: '/hub/looking-for-game',
        icon: '🧩',
        labelKey: 'nav.dropdown.lfg',
      },
      {
        to: '/admin/hub/meetups',
        icon: '📅',
        labelKey: 'nav.dropdown.meetups',
      },
    ],
  },
];
